<!--
******************************************************************************************************
Program ID:
Author:             Dickion To
Date:               2019-01-21
Purpose:            A module for providing user info
Inputs:
Returns:
Copyright:          All the intellectual rights belong to  Airport Authority Hong Kong
------------------------------------------------------------------------------------------------------
Revision History
------------------------------------------------------------------------------------------------------
Initial Version:    2019-01-21
******************************************************************************************************
-->
<template>
  <b-nav-item-dropdown right>
    <template slot="button-content">
      <em>{{portalUserId}}</em>
    </template>
    <b-dropdown-item v-on:click='logout' href="#">Signout</b-dropdown-item>
    <b-dropdown-item v-on:click='reloadAccessRight' href="#">Reload Access Right</b-dropdown-item>
    <b-dropdown-item 
      v-if="userManagementVisible && isAGISAdmin" 
      :to="{ path: '/user-management' }" href="#">User Manager</b-dropdown-item>
  </b-nav-item-dropdown>
</template>
<script>
import PortalAuth from '@/service/portalAuth';

export default {
  name: 'user',
  props: {
    userManagementVisible: {
      default: true,
      type: Boolean
    }
  },
  components: {
    PortalAuth,
  },
  created: function () {
  },
  data:function(){
      return {
        portalUserId: '',
        isAGISAdmin: false,
      }
  },
  mounted:function() {
    this.portalUserId = this.$root.$refs.app.portalUserId;
    this.isAGISAdmin = this.$root.$refs.app.isAGISAdmin;
  },
  methods:{
      logout: function(){ 
        var portalAuth = new PortalAuth();
        portalAuth.logout(this.$router);
      },
      reloadAccessRight: function() {
        this.$root.$refs.app.loadAccessRight();
      },
  }
}
</script>

<style scoped>
[v-cloak] {
  display: none;
}
*,
*::before,
*::after {
  box-sizing: border-box;
  min-height: 0.01px;
}

.btn.sub-system{
    white-space:normal;
    background-color:#258dc8 ;
    border-color: #258dc8 ;
}
.btn.sub-system:hover {
    background-color:#258dc8 ;
    border-color: #258dc8 ;
}
.system-admin{
    color: black
}
</style>



// WEBPACK FOOTER //
// src/components/ui-components/User.vue